import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "./types";
import { BatchActionType } from "../../Models/Batch";
import apiClient from "../api";
import mappers from "./mappers";
import ActionType from "../../Models/ActionType";

function* handleFetchContracts(action: ActionType) {
  try {
    const { data } = yield call(apiClient.get, "contracts");
    const contracts = data.map((c: any) => mappers.contracts.mapToContract(c));
    yield put({ type: types.FETCH_CONTRACTS_SUCCESS, payload: contracts });
  } catch (e: any) {
    yield put({ type: types.FETCH_CONTRACTS_FAILURE });
    console.log(e);
  }
}

const translatorSagas = [
  takeLatest(types.FETCH_CONTRACTS, handleFetchContracts),
];

export default translatorSagas;
